import { Box } from "@mui/system"
import CACTabs from "./CACContent/CACTabs"

const CAC = () => {
  return (
    <>
        <Box sx={{ px: 2 }}>
            <CACTabs />
        </Box>
    </>
  )
}

export default CAC